
import React from "react";
import { 
  RadarChart, PolarGrid, PolarAngleAxis, PolarRadiusAxis, 
  Radar, Tooltip, ResponsiveContainer, Legend 
} from "recharts";

export function OSDistributionChart() {
  // OS distribution data with new color palette
  const data = [
    { name: 'macOS', value: 124, fullMark: 150 },
    { name: 'Windows', value: 98, fullMark: 150 },
    { name: 'Linux', value: 45, fullMark: 150 },
    { name: 'iOS', value: 78, fullMark: 150 },
    { name: 'Android', value: 52, fullMark: 150 },
  ];

  const CustomTooltip = ({ active, payload }: any) => {
    if (active && payload && payload.length) {
      const total = data.reduce((sum, item) => sum + item.value, 0);
      return (
        <div className="bg-white p-3 shadow-md rounded-md border border-gray-100">
          <p className="font-medium text-sm">{`${payload[0].name}`}</p>
          <p className="text-sm">{`Devices: ${payload[0].value}`}</p>
          <p className="text-xs text-gray-500">{`${Math.round((payload[0].value / total) * 100)}% of total`}</p>
        </div>
      );
    }
    return null;
  };

  return (
    <ResponsiveContainer width="100%" height="100%">
      <RadarChart cx="50%" cy="50%" outerRadius="80%" data={data}>
        <PolarGrid stroke="#E0E0E0" />
        <PolarAngleAxis 
          dataKey="name" 
          tick={{ 
            fontFamily: 'Poppins, sans-serif', 
            fontSize: 11, 
            fill: "#333333" 
          }} 
        />
        <PolarRadiusAxis 
          tick={{ 
            fontFamily: 'Poppins, sans-serif', 
            fontSize: 10,  
            fill: "#666666" 
          }} 
          domain={[0, 150]} 
          angle={30} 
        />
        <Radar 
          name="Devices" 
          dataKey="value" 
          stroke="#6366F1" 
          fill="#6366F1" 
          fillOpacity={0.6} 
        />
        <Tooltip content={<CustomTooltip />} />
        <Legend 
          wrapperStyle={{ 
            fontFamily: 'Poppins, sans-serif', 
            fontSize: 12,
            paddingTop: '10px'
          }}
        />
      </RadarChart>
    </ResponsiveContainer>
  );
}
